import React, { useState, useContext } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import _ from 'lodash';
import {
  IconButton,
  Button,
  Menu,
  MenuItem,
} from '@material-ui/core';
import {
  MoreVert as MoreVertIcon,
} from '@material-ui/icons';
import { useTranslation } from 'react-i18next';
import { WorkReportContext } from './WorkReportForm';

const useStyles = makeStyles(theme => ({
  root: {},
  itemMenu: {
    '& div': {
      minWidth: '120px',
    },
    '& svg': {
      right: '4px',
      position: 'absolute',
    },
  },
}));

const ActionMenu = ({ item, handler }) => {
  const { t } = useTranslation();
  const { 
    itemActions,
    setShowPercentageModal,
    setActiveItem,
    setShowItemSummaryModal,
  } = useContext(WorkReportContext);
  const [anchorEl, setAnchorEl] = useState(null);
  const classes = useStyles();
  const open = Boolean(anchorEl);

  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  }

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleReportAll = (item) => {
    itemActions.reportFullQuantity(item);
    setAnchorEl(null);
  }

  const handleReportPercentage = (item) => {
    setActiveItem(item);
    setShowPercentageModal(true);
    setAnchorEl(null);
  }

  const handleShowPriceComposition = (item) => {
    setActiveItem(item);
    setShowItemSummaryModal(true);
    setAnchorEl(null);
  }


  return (
    <>
      <IconButton
          aria-label="more"
          aria-controls="long-menu"
          aria-haspopup="true"
          onClick={handleMenuClick}
          size="small"
          disableRipple
          style={{ background: '#0967da', borderRadius: '5px', color: '#ffffff' }}
      >
          <MoreVertIcon />
      </IconButton>
      <Menu
        id={`long-menu`}
        anchorEl={anchorEl}
        keepMounted
        open={open}
        onClose={handleClose}
        variant="menu"
        className={classes.itemMenu}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        transformOrigin={{ vertical: 'top', horizontal: 'center' }}
        getContentAnchorEl={null}
      >
        <MenuItem
          key={'item-report-quantity'}
          onClick={() => handleShowPriceComposition(item)}
        >
          {t('Kainos sudėtis')}
        </MenuItem>
        <MenuItem
          key={'item-report-quantity-percent'}
          onClick={() => handleReportPercentage(item)}
        >
          {t('Nurodyti dalį procentais')}
        </MenuItem>
        <MenuItem
          key={'item-report-quantity-full'}
          onClick={() => handleReportAll(item)}
        >
          {t('Aktuoti visą likutį')}
        </MenuItem>
      </Menu>
    </>
  );
}

export default ActionMenu;